import api from './api';

export interface GusBasicData {
  regon?: string;
  nip?: string;
  nazwa?: string;
  wojewodztwo?: string;
  powiat?: string;
  gmina?: string;
  miejscowosc?: string;
  ulica?: string;
  nrNieruchomosci?: string;
  nrLokalu?: string;
  kodPocztowy?: string;
  miejscowoscPoczty?: string;
  typ?: string;
  silosID?: string;
  raw?: string;
}

export async function fetchGusByNip(nip: string): Promise<GusBasicData | null> {
  const res = await api.get('/gus/by-nip', { params: { nip } });
  return (res?.data?.data || null) as GusBasicData | null;
}

